/* 自动生成：透明底产品图清单（detect_all_alpha.py）。
   命中文件名的 <img> 会被加 .emf-trans（灰底缩小+落地位），其余图（实拍/场景照）满幅原样。 */
window.EMF_TRANSPARENT = {
"0-ace1-0612a1c5b118_a7ccf90d-80a3-4b3f-9d9b-2500a8ae2115.png":1,
"054320f4-0935-4f06-bcdb-88cf956583cc.png":1,
"06ef3b2f-6ba2-4693-a3f8-16abe18eb112.png":1,
"09d9d810-923f-4bec-8fea-774b469b6d2a.png":1,
"0b2a0b97-ad1b-4108-b64c-4462e9268972.png":1,
"0f5e8cc3-df4a-40ac-b0bd-5739915c0ab3.png":1,
"0fa97064-bccd-4c4b-af78-5633e1ad099f.png":1,
"0fc78b45-a44c-4032-8ce5-6c122e058dc1.png":1,
"1193a8d8-bd59-43bf-9d00-69abec87e098.png":1,
"12a5b235-a693-49a1-9c3f-701122623bdd.png":1,
"12a5b235-a693-49a1-9c3f-701122623bdd_034b0733-9412-42e6-85b2-fd2bf417e207.png":1,
"12v_3e73fcce-bb89-4c42-a311-edf89116227c.png":1,
"12v_3e74d98f-6589-458a-9cb7-709d2cc3513e.png":1,
"12v_63369c24-2af1-41be-a3be-cb313503dc4f.png":1,
"12v_781759ba-9828-4982-9a6f-79f0f947c80c.png":1,
"12v_942e28a7-332a-4f7a-b101-a6558c74720d.png":1,
"12v_f8d1bbb2-409f-434d-b377-63416be3aab9.png":1,
"151cee2b-f49a-4673-b8d4-fcd079e4c38b.png":1,
"1a910806-5dc2-4226-ad8f-a287e6e44880.png":1,
"213d5a52-a1ab-418f-b5da-20351ab2265c.png":1,
"28ed5656-f7cc-4d51-9675-d8c82ec303c4.png":1,
"2d58cec9-c174-4f9b-9f86-0f03c0ae562b.png":1,
"363ae4a8-95b5-4f9e-933c-bf3c4588380b.png":1,
"3f1e66cb-c1b7-42dd-83c1-6d3457bb83c6.png":1,
"4802725d-f454-4976-be32-a3cd8d5505a3.png":1,
"4b5a0887.png":1,
"4b5a0889.png":1,
"4b5a0895.png":1,
"4b5a0897.png":1,
"4b5a0898.png":1,
"59d58e35-1727-4871-ae98-95b393cd28a1.png":1,
"5d8b077b-508a-4896-b3b7-6032d4db8f36.png":1,
"5ed15b89-a8dc-4841-a3ef-d4fc31143a56.png":1,
"61d52c6a-9033-4554-805a-6fdf51172ffe.png":1,
"6390f766-c67b-4d16-8e50-9bd51dc5e93b.png":1,
"673a8883-95b7-46d2-9d4b-991712fb2f41.png":1,
"67d84759-d340-40af-b90f-7b15629fdff3.png":1,
"6acd3872-843f-4d48-bfbe-6ae4cd565901.png":1,
"7486d8d9-6862-4800-993a-3e7298015d82.png":1,
"74b5088b-8fb3-48a0-ace1-0612a1c5b118.png":1,
"7619eb9f-62a9-4838-8cce-41b9b4341dd3.png":1,
"7f260460-5e79-4863-8459-5c840da13921.png":1,
"81f278aa-a475-40a1-b283-af5fcbb6d843.png":1,
"82b274c6-9a95-4166-aba4-c05f7b5abbd3.png":1,
"845c158d-e325-4948-a75d-a22722f9102f.png":1,
"88f44f6c-79f1-4b5c-bbf6-5274fb98824e.png":1,
"8d92b19e-47b0-48ed-97ba-ee909acdcaaa.png":1,
"93e51fc8-85e2-4167-b42b-6a1667af785b.png":1,
"9bf43535-e366-4e1f-9372-8f0aa94ff741.png":1,
"a34d83f3-3b1a-49bd-9217-80b032f66b9b.png":1,
"a40c4bb7-1057-45d9-9ad4-1f8ea2e2b3a1.png":1,
"a4554870-7388-4b65-a2db-3e23a098601a.png":1,
"a83d0d83-c504-4ad2-961e-6a12b3218be8.png":1,
"b65955a1-0d76-4d07-8db5-d6e0f170d1c7.png":1,
"bf46cc89-7389-4f41-9399-1663ccfaf194.png":1,
"c2023b93-e3da-4953-bc9f-ad64d00d8da6.png":1,
"c985e04b-b97a-45ca-8581-a2a1be33033b.png":1,
"caf0ed87-7ff3-4cef-a125-2b63ed297675.png":1,
"cc199b16-552c-4196-a2a6-0c9ea4af7802.png":1,
"cd69f790-a5a9-4744-b772-f212298217ad.png":1,
"cf7a7004-742c-4c89-b5a6-314b33723e1c.png":1,
"d8d51433-d135-4088-a787-b028a393be77.png":1,
"d9834040-ae02-40eb-b550-1e7085ee3fb1.png":1,
"de843445-6448-45a0-9ef4-cda134752e45.png":1,
"de90198f-22c5-4a87-a6e6-2b24ffe5a036.png":1,
"e34d03eb-ed3d-4f0c-8494-c3894a16495a.png":1,
"e61e7bd8-233c-4ab8-b580-ad819e22fbad.png":1,
"ebec1fd5-f6a1-42a8-ade8-a79ef496571b.png":1,
"edd557ce-10a3-495e-b49e-ccecd1865ea1.png":1,
"f36ced1e-8eec-4d2c-842c-ad4ba25b3c96.png":1,
"f766678d-33ac-4be0-93aa-f639b9b17b63.png":1,
"fabba581-b6ef-483c-bd9e-15158b5e0aa0.png":1,
"fb8757fd-af8e-461e-8c35-58b1cf9b7ea9.png":1
};
(function () {
  function fname(u) {
    try {
      var p = String(u).split('?')[0].split('/');
      var f = p[p.length - 1].toLowerCase();
      /* 剥 Shopify 尺寸后缀（_1200x.png / _400x.jpg 等），还原原始文件名再比对白名单 */
      return f.replace(/_[0-9]+x(?=\.(png|jpe?g|webp|gif)$)/, '');
    } catch (e) { return ''; }
  }
  /* v2 (2026-10-07): stem 前缀匹配 —— 挂载副本 stem_<uuid>.png 自动命中白名单，
     不再需要逐个补双 UUID key（根因：#109 补色后 5 张新副本失配 -> 切色大小不一）。 */
  var STEMS = null;
  function buildStems() {
    STEMS = [];
    for (var k in window.EMF_TRANSPARENT) {
      STEMS.push(String(k).replace(/\.(png|jpe?g|webp|gif)$/, ''));
    }
  }
  function hitList(f) {
    if (!f) return 0;
    if (!STEMS) buildStems();
    for (var i = 0; i < STEMS.length; i++) {
      if (f.indexOf(STEMS[i]) === 0) return 1;
    }
    return 0;
  }
  function apply(img) {
    if (!img || img.tagName !== 'IMG') return;
    img.classList.remove('emf-trans');
    var f = fname(img.currentSrc || img.src || '');
    if (hitList(f)) img.classList.add('emf-trans');
  }
  function scan() {
    var sels = '.product__media img,.pdp-main-media img,.gal-slide .slot-img,.gal-thumbs .slot-img,.ecb-card .card__inner .media img,.mega-menu__card-media img';
    document.querySelectorAll(sels).forEach(apply);
  }
  /* 变体切换等场景换 src 后自动重判（load 不冒泡，用捕获） */
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && (t.closest('.product__media,.pdp-main-media,.gal-slide,.gal-thumbs,.ecb-card,.mega-menu__card-media'))) apply(t);
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
